import { FormErrors } from 'redux-form';
import { ReasonType } from '@Models';

const validate = (
  values: CreateUserBugReportParams,
): FormErrors<CreateUserBugReportParams> => {
  const errors: FormErrors<CreateUserBugReportParams> = {};

  if (values.reasonType == null) {
    errors.reasonType = 'user_bug_report.form.reason_type.error';
  }

  if (!values.report || values.report.length === 0) {
    errors.report = 'user_bug_report.form.report.error';
  }

  return errors;
};
export default validate;

export type CreateUserBugReportParams = {
  reasonType: ReasonType;
  report: string;
  armyId: number;
  unitId: number | null;
  unitOptionId: number | null;
  value: string | null;
};
